var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.formContainer,
        ((_obj = {}),
        (_obj[_vm.$style.verifyMfaFormContainer] = _vm.hasSelectedFactor),
        _obj),
      ],
    },
    [
      _vm.hasNoAvailableMfaFactors
        ? _c(
            "ChooseMfaError",
            _vm._b(
              {
                attrs: {
                  header: "Verify Your Identity",
                  error: _vm.errorMessage,
                  subheader: _vm.subheaderText,
                  buttonProps: {
                    action: _vm.backToLogin,
                    text: "Return To Login",
                  },
                },
              },
              "ChooseMfaError",
              _vm.$props,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.availableFactors.length >= 1
        ? _c(
            "LoginCard",
            {
              attrs: {
                header: _vm.headerText,
                className: _vm.selectedFactor.name,
                showCustomLogo: !_vm.hasSelectedFactor,
              },
            },
            [
              _c(
                "h2",
                {
                  class: [
                    _vm.$style.subheader,
                    ((_obj$1 = {}),
                    (_obj$1[_vm.$style.verifyMfaSubheader] =
                      _vm.hasSelectedFactor),
                    _obj$1),
                  ],
                },
                [_vm._v("\n      " + _vm._s(_vm.subheaderText) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.$style.mfaButtons },
                _vm._l(_vm.availableFactors, function (factor) {
                  return _c(
                    "button",
                    {
                      key: factor.name,
                      class: _vm.$style.mfaButton,
                      attrs: {
                        disabled:
                          factor.name === _vm.$options.webauthn &&
                          !_vm.isWebAuthnSupported,
                        type: "button",
                      },
                      on: {
                        click: function () {
                          return _vm.request(factor.name, {
                            shouldPromptImmediately: true,
                          })
                        },
                      },
                    },
                    [
                      _c("div", { class: _vm.$style.factorIconWrapper }, [
                        _c("img", {
                          class: [_vm.factorClassNames[factor.name]],
                          attrs: {
                            src: factor.iconUrl,
                            "data-test-id": factor.name + "-svg",
                          },
                        }),
                      ]),
                      _vm._v(
                        "\n        " + _vm._s(factor.description) + "\n      "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              !_vm.isWebAuthnSupported
                ? _c("span", { class: _vm.$style.webauthnUnsupported }, [
                    _vm._v(
                      "\n      Security Keys are not supported on this browser.\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("LogoIcon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }